export default __webpack_public_path__ + "static/media/icon-standby-validation.42f14b12.svg";